// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const CONTRACT_CONSENTS_PROPS = {
  checkboxConfig: {
    checkedIcon: { icon: 'icon_symbols_checkmark' },
  },
  radioButton: false,
  variant: VARIANTS.SelectorRowVariants.WITH_CHECKBOX,
};

export { CONTRACT_CONSENTS_PROPS };
